import useStyles from "./styles";
import { CircularProgress } from "@mui/material";

// --| CardCount takes 3 props title, icon and count
const CardCount = ({ title, icon, count, isLoading }) => {
  const classes = useStyles();

  return (
    <div className={classes.cardcount}>
      <div className={classes.left}>
        <h6 className={classes.title}>{title}</h6>
        <p className={classes.count}>
          {isLoading ? (
            <CircularProgress size={30} thickness={5} />
          ) : (
            count
          )}
        </p>
      </div>
      <div className={classes.icon}>{icon}</div>
    </div>
  );
};

export default CardCount;
